<pfx-sidebar-with-confirmation [(visible)]="visible">
  <div class="pfx-sidebar-header">
    <pfx-entity-header
      [title]="'order_details' | i18next: { ns: i18nNamespace }"
      [icon]="icon().icon"
    >
      <pfx-order-header-data [orderId]="orderId()"> </pfx-order-header-data>
    </pfx-entity-header>
  </div>

  <pfx-overview-view
    #canLeaveGuard
    class="mt-4"
    [orderId]="orderId()"
  ></pfx-overview-view>

  <div class="pfx-sidebar-footer">
    <div class="flex flex-row justify-around">
      <a
        [routerLink]="['/orders', orderId()]"
        target="_blank"
        >{{ 'detailed_view' | i18next }}</a
      >

      <a
        [routerLink]="['/dispatching', 'search']"
        [queryParams]="{ orderId: orderId() }"
        target="_blank"
        >{{ 'open_planning' | i18next: { ns: i18nNamespace } }}</a
      >
    </div>
  </div>
</pfx-sidebar-with-confirmation>
